import {
  excludedStatuses,
  storeCloseTimeWarningStatuses,
} from "constants/message";
import { MESSAGE } from "modules/elValidadore";
import flatten from "modules/flatten";

export const buildErrorFromStatusItems = ({
  statusItems = [],
  errorPrefix = "",
  isStoreCloseTimeWarningEnabled = false,
}) => ({
  response: {
    errors: statusItems
      .map((item) => {
        if (item.Code && !item.code) item.code = item.Code;
        return item;
      })
      .filter(({ code }) => !excludedStatuses.includes(code))
      .filter(
        ({ code }) =>
          !isStoreCloseTimeWarningEnabled ||
          !storeCloseTimeWarningStatuses.includes(code)
      )
      .map((item) => {
        const detail = item.pulseCode || item.code;
        const message = item.pulseText ? `: ${item.pulseText}` : "";
        item.detail = `${errorPrefix}${detail}${message}`;
        return item;
      }),
  },
});

export const buildErrorFromInvalidProps = (invalidProps = {}) => ({
  response: {
    errors: Object.values(invalidProps)
      .reduce(flatten, [])
      .filter((message) => message !== MESSAGE.MISSING)
      .map((message) => ({ detail: message })),
  },
});

export default buildErrorFromStatusItems;
